import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { AuthService } from '../Services/auth-service.service';
import { RoleService } from '../Services/role.service';
import { HeaderService } from '../Services/header.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private authorize: AuthService, private roles: RoleService, private header: HeaderService, private router: Router) {
    this.addNoteSub = this.roles.canAddNote$.subscribe(
      auth => {
        this.canAddNotes = auth;
      });

    this.addAppsSub = this.roles.canAddApp$.subscribe(
      auth => {
        this.canAddApps = auth;
      });
  }

  addNoteSub: Subscription;
  canAddNotes: boolean;
  addAppsSub: Subscription;
  canAddApps: boolean;

  private clear = (): Promise<boolean> => {
    return new Promise((resolve) => { resolve(true); });
  }

  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let check: Promise<boolean>;
    if (state.url === '/noteEntry' || state.url.indexOf('publishEmail') >= 0) {
      check = this.canAddNote();
    } else if (state.url === '/applicationEntry') {
      check = this.canAddApp();
    } else {
      check = this.clear();
    }

    return new Promise((resolve) => {
      this.authorize.isAuthenticated().then((auth) => {
        this.header.checkAuth(auth);
        if (auth) {
          check.then((perm) => {
            if (!perm) {
              this.router.navigate(['/administration'], { replaceUrl: true });
            }
            resolve(perm);
          });
        } else {
          this.handleAuthorization(auth, state);
          return auth;
        }
      });
    });
  }

  public canAddApp = (): Promise<boolean> => {
    return new Promise((resolve) => {
      if (!(this.canAddApps == null)) {
        resolve(this.canAddApps);
      } else {
        this.roles.getUserRoles().then(() => {
          resolve(this.canAddApps);
        });
      }
    });
  }

  public canAddNote = (): Promise<boolean> => {
    return new Promise((resolve) => {
      if (!(this.canAddNotes == null)) {
        resolve(this.canAddNotes);
      } else {
        this.roles.getUserRoles().then(() => {
          resolve(this.canAddNotes);
        });
      }
    });
  }

  private handleAuthorization(isAuthenticated: boolean, state: RouterStateSnapshot) {
    if (!isAuthenticated) {
      this.authorize.login();
    }
  }
}
